import React from 'react';
import styles from './ScrollableContainer.module.scss';

const ScrollableContainer = ({ children, className = '', style = {} }) => {
  return (
    <div className={`${styles.objectsListContainer} ${className}`}>
      <div className={styles.objectsListBody} style={style}>
        {children}
      </div>
    </div>
  );
};

export default ScrollableContainer;
